module.exports = __webpack_public_path__ + "media/images/common/project_active_left-ed852c45a2f1c7f24a2973f58cb786d0.png";